import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { projectsApi } from 'src/Services/API';

export type DeleteProjectCommentVariables = {
  projectId: string;
  assetId: string;
  commentId: string;
};

export const useDeleteProjectComment = (
  options?: UseMutationOptions<void, unknown, DeleteProjectCommentVariables>
) => {
  const queryClient = useQueryClient();

  return useMutation<void, unknown, DeleteProjectCommentVariables>(
    'delete-project-comment',
    async (data: DeleteProjectCommentVariables) => {
      await projectsApi.projectsControllerRemoveComment(
        data.projectId,
        data.commentId,
        data.assetId
      );
    },
    {
      ...options,
      onSuccess(data, variables, context) {
        queryClient.invalidateQueries(['fetch-project-comments', variables.projectId]);

        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
